import React, { useState } from 'react';

import About from './About';
import AnotherDomain from './AnotherDomain';
import BeyondCloudflare from './BeyondCloudflare';
import Cloudflare1xxxErrors from './Cloudflare1xxxErrors';
import Contact from './Contact';
import GameOriginDnsError1016Fix from './GameOriginDnsError1016Fix';
import MainPage from './MainPage';
import NetworkError1016 from './NetworkError1016';
import OriginDnsSolution from './OriginDnsSolution';
import PartialZoneSolved from './PartialZoneSolved';
import Secured1016OriginDns from './Secured1016OriginDns';
import StreamError1016Solutions from './StreamError1016Solutions';
import PrivacyPractice from './PrivacyPractice';
import ThirdPartySolutions from './ThirdPartySolutions';
import PrivacyRights from './PrivacyRights';
import CalendarYearPrivacy from './CalendarYearPrivacy';

function CurrentPage() {
  const [activePage, setActivePage] = useState('main');

  // 2. Helper function to render the correct component based on state
  const renderComponent = () => {
    switch (activePage) {
      case 'main':
        return <MainPage />;
      case 'about':
        return <About />;
      case 'anotherDomain':
        return <AnotherDomain />;
      case 'beyondCloudflare':
        return <BeyondCloudflare />;
      case 'cloudflare1xxxErrors':
        return <Cloudflare1xxxErrors />;
      case 'calendarYearPrivacy':
        return <CalendarYearPrivacy />;
      case 'contact':
        return <Contact />;
      case 'gameOriginDnsError1016Fix':
        return <GameOriginDnsError1016Fix />;
      case 'networkError1016':
        return <NetworkError1016 />;
      case 'originDnsSolution':
        return <OriginDnsSolution />;
      case 'partialZoneSolved':
        return <PartialZoneSolved />;
      case 'secured1016OriginDns':
        return <Secured1016OriginDns />;
      case 'streamError1016Solutions':
        return <StreamError1016Solutions />;
      case 'privacyPractice':
        return <PrivacyPractice />;
      case 'privacyRights':
        return <PrivacyRights />;
      case 'thirdPartySolutions':
        return <ThirdPartySolutions />;
      default:
        return <MainPage />;
    }
  };

  return (
    <div>
      <div class = "App-header">
        <nav class = "header">
          <div class = "nav-content">
            <div class = "nav-zones">
              <h1 class = "benvegelnav">
                BEN VEGEL
              </h1>

              <button onClick={() => setActivePage('main')} class = "navigation">MAIN</button>
              <button onClick={() => setActivePage('about')} class = "navigation">ABOUT PAGE</button>
              <button onClick={() => setActivePage('anotherDomain')} class = "navigation">ANOTHER DOMAIN</button>
              <button onClick={() => setActivePage('beyondCloudflare')} class = "navigation">BEYOND CLOUDFLARE</button>
              <button onClick={() => setActivePage('calendarYearPrivacy')} class = "navigation">CALENDAR YEAR PRIVACY</button>
              <button onClick={() => setActivePage('cloudflare1xxxErrors')} class = "navigation">CLOUDFLARE 1XXX ERRORS</button>
              <button onClick={() => setActivePage('contact')} class = "navigation">CONTACT PAGE</button>
              <button onClick={() => setActivePage('gameOriginDnsError1016Fix')} class = "navigation">GAME ORIGIN DNS ERROR 1016 FIX</button>
              <button onClick={() => setActivePage('networkError1016')} class = "navigation">NETWORK ERROR 1016</button>
              <button onClick={() => setActivePage('originDnsSolution')} class = "navigation">ORIGIN DNS SOLUTION</button>
              <button onClick={() => setActivePage('partialZoneSolved')} class = "navigation">PARTIAL ZONE SOLVED</button>
              <button onClick={() => setActivePage('privacyPractice')} class = "navigation">PRIVACY PRACTICE</button>
              <button onClick={() => setActivePage('privacyRights')} class = "navigation">PRIVACY RIGHTS</button>
              <button onClick={() => setActivePage('secured1016OriginDns')} class = "navigation">SECURED 1016 ORIGIN DNS</button>
              <button onClick={() => setActivePage('streamError1016Solutions')} class = "navigation">STREAM ERROR 1016 SOLUTIONS</button>
              <button onClick={() => setActivePage('thirdPartySolutions')} class = "navigation">THIRD-PARTY SOLUTIONS</button>
            </div>
          </div>
        </nav>
      </div>

      <div className="content-area">
        {renderComponent()}
      </div>

      <div class = "App-footer">
        <div class = "app-footer-empty">

        </div>
      </div>
    </div>
  );
}

export default CurrentPage;
